import { render, staticRenderFns } from "./HealthXueYangChart.vue?vue&type=template&id=0fe520cb&scoped=true&"
import script from "./HealthXueYangChart.vue?vue&type=script&lang=js&"
export * from "./HealthXueYangChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe520cb",
  null
  
)

export default component.exports